import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['shadow', 0.25],
        ['sledRunner', 0.75],
      ],
      d: 'M-2,-2h1v1h-1zM-1.5,-1h0.5v1h-0.5z',
    },
    {
      paint: 'sledRunner',
      d: 'M2.5,-2.5h1v0.5h-1zM1.5,-2h0.5v0.5h-0.5zM3,-2h0.5v0.5h-0.5zM-0.5,-1.5h1v2.5h-1zM1,-1.5h0.5v0.5h-0.5zM2,-1.5h0.5v0.5h-0.5zM1.5,-1h0.5v0.5h-0.5zM1,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['eggWhite', 0.42],
        ['sledRunner', 0.58],
      ],
      d: 'M0,-2.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.24],
        ['sledRunner', 0.76],
      ],
      d: 'M0.5,-1.5h0.5v2h-0.5zM-2,-1h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['eggWhite', 0.32],
        ['sledRunner', 0.68],
      ],
      d: 'M-1,-2h2v0.5h-2zM2,-2h1v0.5h-1zM-1,-1.5h0.5v2h-0.5zM1.5,-1.5h0.5v0.5h-0.5zM1,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'sproutGreen',
      d: 'M0,-3.5h0.5v0.5h-0.5zM-0.5,-3h1.5v0.5h-1.5zM-1,-2.5h1v0.5h-1zM0.5,-2.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 49,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
